var map = {
	"./en/1/nav2_active.png": 10384,
	"./fi/1/nav2_active.png": 32046,
	"./in/1/nav2_active.png": 89332,
	"./th/1/nav2_active.png": 21053,
	"./tw/1/nav2_active.png": 18634,
	"./zh/1/nav2_active.png": 27155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87668;